import { DictionaryDefinition } from "./DictionaryDefinition";

export class NullDictionaryDefinition extends DictionaryDefinition {
  constructor(word: string) {
    const empty = "-";
    super(word, empty, empty, "(loading...)", empty);
  }

  get isPopulated() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./stores/dictionary/NullDictionaryDefinition.ts